import React, { Component } from 'react'
import {Platform, View, FlatList, StyleSheet} from 'react-native'
import { JDText, JDDevice, JDMta } from '@jdreact/jdreact-core-lib'
import {setWebHeaderTitle} from '../../utils/ut.web'
import styles from './styles'

import PageContainer from '../../components/PageContainer'
import FlatListFooter from '../../components/FlatListFooter'
import HouseDesItem from "./components/HouseDesItem"
import PropTypes from "prop-types";
import { queryHouseResourceDescribeList  } from '../../utils/api'
export default class HouseDes extends Component {
	static contextTypes = {
		router: PropTypes.object
	};
	constructor (props) {
		super(props);
		this.state = {
			requestParam: {
				pageNum: 0,
				pageSize: 10
			},
			statusData: {
				isListFetching: false,  // 正在加载数据
				error: null,            // 出错
				firstGet: true,          // 在第一次数据请求返回之前，不设置加载圈
				hasNext: true, // 是否还有数据
				isLastPage: false // 是否是最后一页
			},
			houseDesData: [], // 房源描述数据
		}
	}
	componentDidMount () {
		if (Platform.OS === "web") {
			setWebHeaderTitle("京东房产-房源描述");
		}
		let cityId = this.props.cityid || "";
		JDMta.isReportDefaultPageParam = false;
		JDMta.sendPvData("", cityId+"", "SHouse_HouseDescribeList");
		this._onEndReached();
	}
	_onEndReached = () => {
		let shouldFetch = true; // 是否请求数据
		this.setState((prevState) => {
			let {requestParam, statusData} = prevState;
			if (statusData.isListFetching) { // 若是正在加载数据，则不再向后端请求数据
				shouldFetch = false;
				return;
			}
			if (!statusData.hasNext || statusData.error != null) { // 若是到最后一页或后端数据请求失败
				return {
					...prevState,
					requestParam: {
						...requestParam,
						pageNum: prevState.requestParam.pageNum
					},
					statusData:{
						...statusData,
						isListFetching: true,
						error: null
					}
				}
			} else {
				return {
					...prevState,
					requestParam: {
						...requestParam,
						pageNum: prevState.requestParam.pageNum + 1
					},
					statusData:{
						...statusData,
						isListFetching: true,
						error: null
					}
				}
			}
		}, () => {
			if(shouldFetch && this.state.statusData.hasNext){
				this.fetchHouseDesData();
			}
		});
	}
	_renderHouseDesItem = (desItemInfo) => {
		var houseDesItem = desItemInfo.item;
		return <HouseDesItem houseDesItem={houseDesItem} cityId={this.props.cityid}></HouseDesItem>

	} // 渲染房源描述数据
	_separator() {
		// return <JDText style={styles.rowLine}></JDText>
		return <View style={styles.rowLine}></View>
	}
	_renderFooter = ()  => {
		// let {statusData} = this.state;
		// if (statusData.isLastPage) {
		// 	return (
		// 		<View style={houseDesStyles.hintBox}>
		// 			<JDText style={houseDesStyles.line}/>
		// 			<JDText style={houseDesStyles.hint}>没有更多啦</JDText>
		// 			<JDText style={houseDesStyles.line}/>
		// 		</View>
		// 	)
		// } else if(statusData.isListFetching && !statusData.firstGet) {
		// 	return (
		// 			<View style={houseDesStyles.footer}>
		// 				<ActivityIndicator />
		// 				<JDText>正在加载更多数据...</JDText>
		// 			</View>
		// 	);
		// } else {
		// 	return(<View></View>)
		// }
		if(this.state.statusData.firstGet){
			return(<View></View>)
		}else {
			return (
					<FlatListFooter data={this.state.statusData}/>
			)
		}
	};
	fetchHouseDesData = () => {
		let params = this.state.requestParam;
		let pageNum = params.pageNum;
		params.houseResourceId = this.props.parmkey || "" ;

		queryHouseResourceDescribeList(params).then((res) => {
			let houseDesData = res.resourceDescribeDTOS;
			if (houseDesData instanceof Array && houseDesData.length > 0) {
				houseDesData = this.state.houseDesData.concat(houseDesData);
			}
			let isLastPage = false;
			let hasNext = true;
			if (pageNum >= res.totalPage) {
				isLastPage = true;
				hasNext = false;
			}
			this.setState({
				...this.state,
				statusData: {
					isListFetching: false,
					error: null,
					firstGet: false,
					isLastPage: isLastPage,
					hasNext: hasNext
				},
				houseDesData: houseDesData
			});
		}).catch(err => {
			this.setState({
				...this.state,
				statusData: {
					isListFetching: false,
					error: err,
					data: null,
					firstGet: false,
					hasNext: true
				}
			});
		});
	};
	render() {
		return (
			<PageContainer title="京东房产-房源描述" bodyStyle={houseDesStyles.houseDesContainer}>
				<FlatList
					style={houseDesStyles.houseDesList}
					data={this.state.houseDesData}
					renderItem={this._renderHouseDesItem}
					ListFooterComponent={this._renderFooter}
					onEndReached={()=>{this._onEndReached()}}
					onEndReachedThreshold={0.5}
					ItemSeparatorComponent={this._separator}
					keyExtractor={(item, index) => 'houseDes_'+index}
				/>
			</PageContainer>
		)
	}
}
const houseDesStyles = StyleSheet.create({
	houseDesContainer: {
		backgroundColor: '#fff'
	},
	houseDesList: {
		paddingHorizontal: JDDevice.getRpx(30),
		paddingTop: JDDevice.getRpx(30)
	},
	hintBox: {
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: JDDevice.getRpx(40),
		marginBottom: JDDevice.getRpx(60)
	},
	line: {
		width: JDDevice.getRpx(48),
		height: JDDevice.getRpx(2),
		backgroundColor: '#aaa'
	},
	hint: {
		fontSize: JDDevice.getFontSize(28),
		color: '#848689',
		marginHorizontal: JDDevice.getRpx(10)
	},
	title: {
		fontSize: 15,
		color: 'blue',
	},
	footer:{
		flexDirection:'row',
		height:24,
		justifyContent:'center',
		alignItems:'center',
		marginBottom:10,
	},
	content: {
		fontSize: 15,
		color: 'black',
	}
});
